module.exports = __webpack_public_path__ + "static/img/bg4.dda3eb36.png";